export function lowPriorityCallback(vm: Vue, cb: Function) {
	if ('requestIdleCallback' in window) {
		window.requestIdleCallback(() => cb());
	} else {
		vm.$nextTick(() => cb());
	}
}
